import { CommonModule } from '@angular/common';
import { AfterViewInit, Component, OnInit } from '@angular/core';
import { RouterModule } from '@angular/router';
import { MsalService } from '@azure/msal-angular';
import { PreloaderService } from '@core';
import { MtxLoaderModule } from '@ng-matero/extensions/loader';
import { LoadingService } from '@shared/services/loading.service';

@Component({
  selector: 'app-root',
  template:
    '<mtx-loader [loading]="loadingService.isLoading | async"><router-outlet></router-outlet></mtx-loader>',
  imports: [RouterModule, CommonModule, MtxLoaderModule],
})
export class AppComponent implements AfterViewInit, OnInit {
  constructor(
    private msalService: MsalService,
    private preloader: PreloaderService,
    public loadingService: LoadingService
  ) {}

  ngOnInit(): void {
    this.msalService.handleRedirectObservable().subscribe();
  }

  ngAfterViewInit() {
    this.preloader.hide();
  }
}
